import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "mg-toggle-knob" };
const _hoisted_2 = ["src"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MGToggle',
    props: {
        modelValue: { type: Boolean, default: false },
        size: { default: 'large' },
        tick: { type: Boolean, default: true }
    },
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const sizeClass = computed(() => {
            return `mg-toggle--${props.size}`;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["mg-toggle", [sizeClass.value, { on: _ctx.modelValue }]]),
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', !_ctx.modelValue)))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (_ctx.modelValue && _ctx.tick)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: require('@/assets/check-tick.svg'),
                            class: "mg-toggle-tick",
                            alt: ""
                        }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
